<template>
  <div class="nav-container">

    <nav :class="{simple:true, show:$route.meta.hideMenu, inverted:$route.meta.inverted}">
      <div class="logo" @click="routePush('/', {item:'logo'})"><img src="/static/img/KMS_logo_white.svg" alt="Logo von Kino, Mond & Sterne mit Slogan 'Die Besten Nächte des Jahres'"/></div>
      <div class="back" @click="goBack()" >
        <img src="/static/img/Arrow.svg" alt=""/> <span>Zurück zur Übersicht</span>
      </div>
    </nav>

    <nav :class="{hide:$route.meta.hideMenu, inverted:$route.meta.inverted}">
      <div class="logo" @click="closeMobileMenu();routePush('/', {item:'logo'})"><img src="/static/img/KMS_logo_white.svg"  alt="Logo von Kino, Mond & Sterne mit Slogan 'Die Besten Nächte des Jahres'"/></div>
      <navigation :menu="1"></navigation>
      <div class="systray">
          <!--
          <kms-a class="noStroke" to="/user"><img src="/static/img/user.svg" /></kms-a>
          <kms-a class="noStroke count" to="/cart">
            <template v-if="false">
              <img src="/static/img/basket.svg" />
            </template>
            <template v-else>
              <img src="/static/img/basket_cut.svg" /><span>22</span>
            </template>
          </kms-a>
        -->
          <div class="burger-menu">
            <burger-menu></burger-menu>
          </div>

      </div>

    </nav>
  </div>
</template>

<script>
import Navigation from '../elements/Navigation.vue';
import BurgerMenu from '../elements/BurgerMenu.vue';
export default {
  components: {  Navigation, BurgerMenu },
  data () {
    return {

    }
  },
  methods: {
    closeMobileMenu: function(){
      this.$event.$emit('close');
    },
    goBack:function(){
      var vm=this;
      vm.$event.$emit('userinteraction', {item:'toolbar go back', from:this.$route.path});
      vm.$router.go(-1);
    }
  },
  mounted:function(){
     this.$event.$emit('close');
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';
$logo-width:11em;
nav {
  font-size:0.93em;
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  width:100%;
  margin: 0 auto;
  left:0;
  right:0;
  top:40px;
  padding:0 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: opacity 1s ease, filter .3s ease;
  transition-delay: 1.5s, 1.5s, 1.5s, 1.5s, 1.5s; /* repeat transition delay for browser prefixes*/
  @include for-size(phone-only) {
    font-size:1em;
    top:20px;
    height: 2em;
  }

  &.inverted {
    transition-delay: 0s;
    .logo, ul, .systray a {
      filter: invert(100%);
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      .logo{
        background-image:url(/static/img/KMS_logo_black.png);
      }
      /deep/ ul li a {
        color:black;
      }
    }

  }
  &.simple {
    &.show {
      .logo {
          //transition: 1.5s all 1s ease;
          transition: 1.5s opacity 1s ease, 1.5s transform 1s ease, 1.5s filter .3s ease;
          transform:translatex( calc(50vw - #{$logo-width}) );
          @include for-size(phone-only) {
            transform:translatex( calc(100vw - #{$logo-width}) );
          }
      }
      .back {
        transform:translatex( 0% );
        transition: 1.5s opacity 1s ease, 1.5s transform 1s ease,  1.5s filter .3s ease;
        left:5vw;

      }
    }

    .logo {
        //transition: 1.5s all 0s ease;
        transition: 1.5s opacity 0s ease, 1.5s transform 0s ease,  1.5s filter .3s ease;
        transition-delay: 0s, 0s, 0s, 0s, 0s;
        transform:translatex( 0% );
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          opacity: 0;
        }
    }
    .back {
      transform:translatex( -30vw );
      transition: 0s opacity 2s ease, 0s transform 2s ease,  0s filter .3s ease;
      //transition: 0 all 2s ease;
      color: white;
      cursor: pointer;
      position: absolute;
      left:-20vw;
      white-space: nowrap;
      font-weight: 700;
      //transition: 1.5s all 0s ease;
      transition: 1.5s opacity 0s ease, 1.5s transform 0s ease, 1.5s filter 0s ease;
      @include for-size(phone-only) {
        line-height:11px;
      }

      img {
        width: 4vw;
        transform: rotate(180deg);
        margin-right: 5%;
        @include for-size(phone-only) {
          width: 20px;
        }
      }

      span {
        font-size: 1em;
        @include for-size(phone-only) {
          font-size: 11px;
        }
      }
    }

    &.inverted{
      .back{
        color:black;
        img {
          filter: invert(100%);
        }
      }
    }
  }
  ul {
    transition: all 1s ease;
    transition-delay: 0.5s;
    @include for-size(phone-only) {
      display:none;
    }
  }

  &.hide {
    transition-delay: .5s;
    opacity: 0;
    pointer-events: none;
  }

  .back {
    color: white;
    cursor: pointer;
    position: absolute;
    left:-5%;
    white-space: nowrap;
    font-weight: 700;
    //transition: 1.5s all 0s ease;
    transition: 1.5s opacity 0s ease, 1.5s transform 0s ease, 1.5s filter 0s ease;

    img {
      width: 4vw;
      transform: rotate(180deg);
      margin-right: 5%;
    }
  }

  .logo{
    //transition: all 1s ease;
    transition: opacity 1s ease, transform 1s ease, filter 0.3s ease;
    transition-delay: 0.5s;
    transform:translatex( 0 );
    z-index: 99;
    cursor:pointer;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        background-image:url(/static/img/KMS_logo_white.png);
        background-size:contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    img {
      width:$logo-width;
      height:auto;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        visibility: hidden;
      }
      @include for-size(phone-only) {
        width:120px;
      }
    }
  }
  .systray{
    display: flex;
    justify-content: space-between;
    width:6em;
    @include for-size(phone-only) {
      width:10em;
    }
    a{
      img {
        width:1.5em;
        filter: none;
        transition: filter 0.5s ease;
        &:hover {
          filter: drop-shadow(5px 5px 5px #fff);
        }
      }
      &.count {
        position: relative;
        span {
          color: white;
          position: absolute;
          border: 2px solid white;
          border-radius: 100px;
          font-size: 0.6em;
          padding: 5% 15%;
          left: 45%;
          margin-top: 45%;
        }
      }
    }
    .burger-menu {
      width: 2em;
      position: absolute;
      top: 0em;
      right: 2em;
      padding: 0;
      display: none;
      @include for-size(phone-only) {
        display: block;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/Toolbar.vue